module.exports = __webpack_public_path__ + "img/active5.913cb267.png";